module.exports = __webpack_public_path__ + "static/media/bronze_test_banner.998474c1.png";